var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    fill: "none",
    stroke: "#888b8d",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.783,
    cy: 15.133,
    r: 3.333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.45 19.667V9.133c0-1.467-1.2-2.667-2.667-2.667h-20c-1.467 0-2.667 1.2-2.667 2.667v12c0 1.467 1.2 2.667 2.667 2.667H17.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.116 19.801h2.667m12-9.334h2.667m-3.467 10.534c-2.533.133-4.533 2.133-4.533 4.667s2.133 4.667 4.667 4.667c1.867 0 3.467-1.067 4.133-2.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.116 27.534c-2.533 0-4.667-2.133-4.667-4.667s2.133-4.667 4.667-4.667 4.667 2.133 4.667 4.667-2 4.667-4.667 4.667"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencies);
export default __webpack_public_path__ + "static/media/Currencies.c8301dd2cb4d6ee75275371cb36be8f7.svg";
export { ForwardRef as ReactComponent };